import { operatorNeedsValue } from './interpretation-rule-field-options';
import type { InterpretationRule, RuleAction, RuleCondition } from './types';

export function isConditionValid(condition: RuleCondition): boolean {
  if (!condition.field || !condition.operator) return false;
  if (!operatorNeedsValue(condition.operator)) return true;
  return (
    condition.value != null && String(condition.value).trim().length > 0
  );
}

export function isActionValid(action: RuleAction): boolean {
  if (!action.field) return false;
  return action.value != null && String(action.value).trim().length > 0;
}

export function isRuleValid(
  rule: Pick<InterpretationRule, 'name' | 'conditions' | 'actions'>
): boolean {
  if (!rule.name?.trim()) return false;
  return isRuleReadyToSave(rule);
}

/** Save can proceed once required updates (and any conditions) are filled. */
export function isRuleReadyToSave(
  rule: Pick<InterpretationRule, 'conditions' | 'actions'>
): boolean {
  if (!rule.actions?.length || !rule.actions.every(isActionValid)) return false;
  if (rule.conditions?.length) {
    return rule.conditions.every(isConditionValid);
  }
  return true;
}
